import classNames from "classnames";
import getOr from 'lodash/fp/getOr';
import { DComponent } from "../../../../../../components/DComponent";
import Env from "../../../../../../environments";
import { GLOBAL_CONSTANTS } from "../../../../../../global/constants";
import { LocalStorage } from "../../../../../../models/LocalStorage";

export default class StripePayment extends DComponent {
  constructor({
    parent,
    id,
    chargeSecret,
    onConfirmSuccess = () => { },
    onConfirmError = () => { },
    onContinue = () => { },
    onCancel = () => { },
    stripe,
    elements
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("StripePayment"),
    }, true);
    this.chargeSecret = chargeSecret;
    this.onConfirmSuccess = onConfirmSuccess;
    this.onConfirmError = onConfirmError;
    this.onContinue = onContinue;
    this.onCancel = onCancel;
    this.stripe = stripe;
    this.elements = elements;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "StripePayment");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.setupStripe();

    $(".btn.btn-ok", this.element).on("click", () => {
      if (this.checkEnablePurchase(true)) {
        this.isLoading(true);
        typeof this.onContinue == "function" && this.onContinue();
      }
    });

    this.element.on('hidden.bs.modal', () => {
      $("html, body").css("overflow", "auto");
      this.isLoading(false);
      typeof this.onCancel == "function" && this.onCancel();
    })
  }

  // eslint-disable-next-line no-unused-vars
  setupStripe() {
    try {
      // eslint-disable-next-line no-undef
      const stripe = Stripe(Env.DUTY_CAST_STRIPE_API_KEY);
      this.stripe = stripe;

      const elements = stripe.elements({ locale: LocalStorage.getLanguage() || "en" });

      this.elements = elements;

      const style = {
        base: {
          iconColor: '#666EE8',
          color: '#222222',
          lineHeight: '38px',
          fontWeight: 400,
          fontFamily: 'Proxima Nova',
          fontSize: '14px',

          '::placeholder': {
            color: '#747474',
          },
        },
      };

      const cardElement = elements.create('card', {
        hidePostalCode: true,
        style: style,
        showIcon: true,
      });
      cardElement.mount('#card-number');

      cardElement.on('change', (e) => {
        this.handleMessage(e);
      });

      $("#card_holder", this.element).on('leave', (e) => {
        cardElement.focus();
      });

    } catch (error) {
      console.error(error)
    }
  }

  show() {
    $("html, body").css("overflow", "hidden");
    let lang = LocalStorage.getLanguage();
    $(".guaranteed", this.element).attr("data-lang", lang);
    $(this.element).modal("show");
  }

  hide() {
    $(".btn-ok", this.element).removeClass("loading");
    $(this.element).modal("hide");
  }

  isLoading(isLoad) {
    if (isLoad) {
      $(".btn-ok", this.element).addClass("loading");
    } else {
      $(".btn-ok", this.element).removeClass("loading");
    }
  }

  confirmStripe() {
    this.stripe.confirmCardPayment(this.chargeSecret, {
      payment_method: {
        card: this.elements.getElement("card"),
        billing_details: {
          name: $('input[name=card-hoder]', this.element).val() || "name",
        },
      },
      setup_future_usage: 'off_session'
    }).then((result) => {
      if (result.paymentIntent) {
        typeof this.onConfirmSuccess === "function" && this.onConfirmSuccess(result.paymentIntent.id);
      } else {
        this.isLoading(false);
        this.handleMessage(result)
        typeof this.onConfirmError === "function" && this.onConfirmError(result);
      }
    }, function (err) {
      this.isLoading(false);
      this.handleMessage(err)
      typeof this.onConfirmError === "function" && this.onConfirmError(err);
    })
  }

  handleMessage(result) {
    setTimeout(() => {
      this.checkEnablePurchase();
    }, 100);

    const error = getOr('', 'error')(result);
    const message = getOr(GLOBAL_CONSTANTS.DEFAULT_ERROR, 'error.message')(result);
    $('.message', this.element).text(error ? message : "");
    $('.message', this.element).attr("data-i18n", "");
    this.isLoading(false);
  }

  checkEnablePurchase(isSubmit = false) {
    if (this.elements.getElement("card")._complete && $("input[name=card-hoder]", this.element).val()) {
      if (isSubmit) {
        $('.message', this.element).text('');
        $('.message', this.element).attr("data-i18n", "");
      }
      return true;
    } else {
      if (isSubmit) {
        $('.message', this.element).text($.i18n("checkout_pleaseEnterCardInformation"));
        $('.message', this.element).attr("data-i18n", "checkout_pleaseEnterCardInformation");
        $("#card_holder", this.element).focus();
      }
      return false;
    }
  }

  /** @param {StripePayment} _data - The text to repeat */
  updateStripe(_data) {
    Object.keys(_data).forEach(key => {
      this[key] = _data[key];
    });
  }
}